import React, { memo } from 'react'
import { SmoothStepEdgeWithContent } from './smooth-step-edge'
import { EdgeWithContentProps } from './common/interface'

export const StepEdgeWithContent = memo((props: EdgeWithContentProps) => (
  <SmoothStepEdgeWithContent {...props} borderRadius={0} />
))
